import { CardMedia, Grid, Hidden, makeStyles, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { FC, useEffect } from "react";
import { scrollToId } from "../../utils/scrollToId";
import { InfoIconOnClick } from "../popover/InfoIconOnClick";
import { SelectButtonWhat } from "../SelectButtonWhat";
import { DecidiTu } from "./DecidiTu";
import { loadTariffe } from "../../store/engine/engineReducer";
import { useDispatch, useSelector } from "react-redux";
import { intermediarioSelector } from "../../store/intermediario/intermediario.selectors";
import {
  completeMovSelector,
  completeMovVivLavSelector,
  completeMovVivSelector,
  loadingMovErrorSelector,
  loadingMovVivErrorSelector,
  loadingMovVivLavErrorSelector,
  tariffeMultipleSelector,
} from "../../store/engine/engine.selectors";
import { PriceCalculated } from "../PriceCalculated";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 91,
    borderRadius: "15px 15px 0 0",
    backgroundColor: theme.palette.secondary.backgroundLight,
    justifyContent: "space-around",
    paddingBottom: 22,
    [theme.breakpoints.down("sm")]: {
      // height: 950,
      paddingTop: 0,
    },
  },
  box: {
    maxWidth: "30%",
    backgroundColor: theme.palette.common.white,
    boxShadow: "0 2px 12px 0 rgba(0,0,0,0.02), 0 10px 30px 0 rgba(0,0,0,0)",
    alignItems: "center",
    padding: "126px 36px 36px 36px",
    position: "relative",
    // height: 395,
    minHeight: 395,
    [theme.breakpoints.down("sm")]: {
      // height: 325,
      minHeight: 325,
      maxWidth: "initial",
      padding: "100px 8% 34px 8%",
      margin: "130px 16px 0 16px",
      "&first-child": {
        marginBottom: 80,
      },
    },
  },
  boxTitle: {
    fontSize: 24,
    fontWeight: 700,
    letterSpacing: 0.23,
    lineHeight: "28px",
    marginBottom: "17px",
    textAlign: "center",
    height: 150,
    minHeight: 150,
    [theme.breakpoints.down("sm")]: {
      marginBottom: 16,
      minHeight: "unset",
      height: "auto",
    },
    [theme.breakpoints.only("md")]: {
      height: 250,
    },
  },
  boxText: {
    fontSize: 16,
    fontWeight: 300,
    letterSpacing: 0,
    lineHeight: "24px",
    marginBottom: "22px",
    minHeight: 100,
    [theme.breakpoints.down("sm")]: {
      marginBottom: 16,
      minHeight: "unset",
      height: "auto",
    },
  },
  footerContainer: {
    borderRadius: "0 0 15px 15px",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.secondary.backgroundLight,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "10%",
      paddingRight: "10%",
      paddingBottom: "16px",
    },
  },
  imageIndividual: {
    position: "absolute",
    top: -80,
    width: 163,
    height: 181,
  },
  imageFamily: {
    position: "absolute",
    top: -80,
    width: 229,
    height: 179,
  },
  footerText: {
    textAlign: "center",
    fontSize: 15,
    letterSpacing: 0,
    lineHeight: "21px",
    fontWeight: 300,
  },
  scrollText: {
    textAlign: "center",
    fontSize: 15,
    letterSpacing: 0,
    lineHeight: "21px",
    fontWeight: 300,
    cursor: "pointer",
  },
  alignCenter: {
    textAlign: "center",
  },
  oval: {
    height: 50,
    width: 90,
    backgroundColor: theme.palette.primary.main,
    borderRadius: "50%",
    position: "absolute",
    border: "2px solid black",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: 70,
    right: 0,
    [theme.breakpoints.only("xs")]: {
      right: -30,
      height: 30,
      width: 75,
    },
    [theme.breakpoints.only("sm")]: {
      right: 20,
    },
    [theme.breakpoints.only("md")]: {
      right: -10,
    },
  },
}));

const scrollToSupport = (): void => scrollToId("support");

export const Cosa: FC = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const intermediarioState = useSelector(intermediarioSelector);
  const tariffeMultiple = useSelector(tariffeMultipleSelector);
  const loadingMovError = useSelector(loadingMovErrorSelector);
  const loadingMovVivError = useSelector(loadingMovVivErrorSelector);
  const loadingMovVivLavError = useSelector(loadingMovVivLavErrorSelector);
  const completeMov = useSelector(completeMovSelector);
  const completeMovViv = useSelector(completeMovVivSelector);
  const completeMovVivLav = useSelector(completeMovVivLavSelector);

  useEffect(() => {
    if (intermediarioState.data && !tariffeMultiple.mov && !tariffeMultiple.movViv && !tariffeMultiple.movVivLav) {
      dispatch(loadTariffe());
    }
  }, [dispatch, intermediarioState.data, tariffeMultiple.mov, tariffeMultiple.movViv, tariffeMultiple.movVivLav]);

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item container xs={12} md={4} className={classes.box} justify={"center"}>
          <CardMedia image="assets/who-family.svg" title="Mobilità Platino CQC" className={classes.imageFamily} />
          <Grid item xs={12} className={classes.alignCenter}>
            <Typography className={classes.boxTitle} variant={"h2"}>
              Mobilità Platino CQC. <br />
              Con Decidi Tu!
              <InfoIconOnClick description={<DecidiTu />} />
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.alignCenter}>
            <Typography className={classes.boxText}>
              Scegli di assicurare i fatti che riguardano la circolazione stradale e i veicoli delle persone assicurate.
            </Typography>
          </Grid>
          <PriceCalculated prezzo={tariffeMultiple.mov} error={!!loadingMovError} />
          <SelectButtonWhat muoversi prezzo={tariffeMultiple.mov} complete={completeMov} />
        </Grid>
        <Grid item container xs={12} md={4} className={classes.box} justify={"center"}>
          <CardMedia
            image="assets/what-vivere.svg"
            title="Mobilità Platino CQC, Vivere Pienamente - Vita Privata e Casa"
            className={classes.imageIndividual}
          />
          <Grid item xs={12} className={classes.alignCenter}>
            <Typography className={classes.boxTitle} variant={"h2"}>
              Mobilità Platino CQC, <br />
              Vivere Pienamente - Vita Privata e Casa. <br />
              Con Decidi Tu!
              <InfoIconOnClick description={<DecidiTu />} />
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.alignCenter}>
            <Typography className={classes.boxText}>
              Scegli di assicurare i fatti che riguardano la circolazione e la vita privata in un&apos;unica soluzione.
            </Typography>
          </Grid>
          <PriceCalculated prezzo={tariffeMultiple.movViv} error={!!loadingMovVivError} />
          <SelectButtonWhat muoversi vivere prezzo={tariffeMultiple.movViv} complete={completeMovViv} />
        </Grid>
        <Grid item container xs={12} md={4} className={classes.box} justify={"center"}>
          <div className={classes.oval}>
            <Typography variant={"h6"}>Novit&agrave;!</Typography>
          </div>
          <CardMedia
            image="assets/what-vivere-muoverti.svg"
            title="Mobilità Platino CQC, Vivere Pienamente - Vita Privata e Casa, Lavoro Dipendente"
            className={classes.imageFamily}
          />
          <Grid item xs={12} className={classes.alignCenter}>
            <Typography className={classes.boxTitle} variant={"h2"}>
              Mobilità Platino CQC, <br />
              Vivere Pienamente - Vita Privata e Casa, <br />
              Lavoro Dipendente. <br />
              Con Decidi Tu!
              <InfoIconOnClick description={<DecidiTu />} />
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.alignCenter}>
            <Typography className={classes.boxText}>
              Scegli di assicurare i fatti che riguardano la circolazione, la vita privata ed il lavoro dipendente tutto
              in un&apos;unica soluzione.
            </Typography>
          </Grid>
          <PriceCalculated prezzo={tariffeMultiple.movVivLav} error={!!loadingMovVivLavError} />
          <SelectButtonWhat
            vivere
            muoversi
            dipendente
            prezzo={tariffeMultiple.movVivLav}
            complete={completeMovVivLav}
          />
        </Grid>
      </Grid>
      <Grid container className={classes.footerContainer}>
        <Typography component="p" className={classes.footerText}>
          Per assicurare te stesso\a e tutte le persone risultanti dal tuo certificato di stato famiglia.
          <br />
          <strong>Contatta il tuo intermediario se vuoi altre soluzioni assicurative.</strong>
          <br />
          Messaggio promozionale. Prima della sottoscrizione leggere il set informativo.
        </Typography>
        <Hidden smDown>
          <Typography
            component="p"
            className={classes.scrollText}
            style={{ fontWeight: "bold" }}
            onClick={scrollToSupport}
          >
            Scorri in basso
          </Typography>
          <Typography component="p" className={classes.scrollText} style={{ marginTop: -5 }} onClick={scrollToSupport}>
            <ExpandMoreIcon />
          </Typography>
        </Hidden>
      </Grid>
    </>
  );
};
